<template>
  <section class="pillars reveal-section" id="pilares" ref="sectionRef">
    <div class="section-header">
      <span class="section-label">Nuestro Propósito</span>
      <h2 class="section-title">Misión y Visión</h2>
      <p class="section-subtitle">Dos pilares que guían cada paso que damos en Guatemala y más allá</p>
    </div>
    <div class="pillars-grid">
      <ion-card class="pillar-card">
        <div class="pillar-icon"><i class="fas fa-book-bible"></i></div>
        <ion-card-header>
          <ion-card-title style="font-family:'League Spartan';font-size:2rem;color:var(--vh-azul-profundo)">Nuestra Misión</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <p>Formar líderes integrales y agentes de transformación mediante modelos educativos de excelencia y planes de trabajo contextualizados. Nos dedicamos a fortalecer las bases teológicas, académicas y emocionales de nuestra comunidad, guiándolos bajo la dirección de Dios para impactar positivamente el entorno social y espiritual.</p>
        </ion-card-content>
      </ion-card>

      <ion-card class="pillar-card">
        <div class="pillar-icon"><i class="fas fa-eye"></i></div>
        <ion-card-header>
          <ion-card-title style="font-family:'League Spartan';font-size:2rem;color:var(--vh-azul-profundo)">Nuestra Visión</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <p>Convertirnos en el referente principal de educación cristiana y misionera en Guatemala, consolidando un colegio acreditado y programas de formación de vanguardia. Aspiramos a ver una comunidad de creyentes con conocimientos actualizados y habilidades prácticas que multipliquen discípulos comprometidos con la transformación profunda.</p>
        </ion-card-content>
      </ion-card>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { IonCard, IonCardHeader, IonCardTitle, IonCardContent } from '@ionic/vue'
import { useScrollReveal } from '@/composables/useAnimations'

const sectionRef = ref<HTMLElement | null>(null)
const { registerReveal } = useScrollReveal()
onMounted(() => registerReveal(sectionRef.value))
</script>

<style scoped>
.pillars {
  background: linear-gradient(180deg, var(--vh-gris-piedra) 0%, var(--vh-blanco) 100%);
  padding: 7rem 5%;
}
.pillars-grid {
  display: grid; grid-template-columns: repeat(2, 1fr);
  gap: 3rem; max-width: 1100px; margin: 0 auto;
}
.pillar-card {
  background: white; padding: 3.5rem;
  border-radius: 30px; box-shadow: 0 15px 50px var(--vh-sombra);
  text-align: center; transition: var(--vh-transicion);
  position: relative; overflow: hidden;
}
.pillar-card::before {
  content: ''; position: absolute; top: 0; left: 0;
  width: 100%; height: 5px;
  background: linear-gradient(90deg, var(--vh-azul-profundo), var(--vh-dorado));
  transform: scaleX(0); transform-origin: left;
  transition: transform 0.5s ease;
}
.pillar-card:hover::before { transform: scaleX(1); }
.pillar-card:hover { transform: translateY(-12px); box-shadow: 0 25px 60px rgba(26, 75, 140, 0.2); }
.pillar-icon {
  width: 90px; height: 90px;
  background: linear-gradient(135deg, var(--vh-azul-profundo), var(--vh-azul-cielo));
  border-radius: 50%; display: flex;
  align-items: center; justify-content: center;
  margin: 0 auto 2rem; font-size: 2.2rem; color: white;
  position: relative; box-shadow: 0 10px 30px rgba(26, 75, 140, 0.3);
}
.pillar-icon::after {
  content: ''; position: absolute; inset: -8px;
  border-radius: 50%; border: 2px dashed var(--vh-dorado);
  animation: spin 25s linear infinite;
}
ion-card-content p { color: #555; line-height: 1.9; font-size: 1.05rem; }

@media (max-width: 768px) {
  .pillars-grid { grid-template-columns: 1fr; }
  .pillar-card { padding: 2rem; }
}
</style>
